import CryptoJS from 'crypto-js';

/**
 * Származtat egy titkosítási kulcsot a Családi Titokból (Family Secret) PBKDF2 segítségével.
 * @param {string} familySecret - A felhasználó által megadott családi titok.
 * @param {string} salt - Só a kulcsszármaztatáshoz (opcionális, de ajánlott).
 * @returns {string} - A származtatott kulcs hex formátumban.
 */
export const deriveKey = (familySecret, salt = 'szno-family-salt') => {
    return CryptoJS.PBKDF2(familySecret, salt, {
        keySize: 256 / 32,
        iterations: 1000
    }).toString();
};

/**
 * Titkosít egy objektumot AES-256 segítségével.
 * @param {object} data - A titkosítandó adat.
 * @param {string} key - A titkosítási kulcs.
 * @returns {string} - A titkosított string (Base64).
 */
export const encryptData = (data, key) => {
    const jsonStr = JSON.stringify(data);
    return CryptoJS.AES.encrypt(jsonStr, key).toString();
};

/**
 * Dekódol egy AES-256-tal titkosított stringet.
 * @param {string} ciphertext - A titkosított adat.
 * @param {string} key - A titkosítási kulcs.
 * @returns {object|null} - A dekódolt objektum vagy null hiba esetén.
 */
export const decryptData = (ciphertext, key) => {
    try {
        const bytes = CryptoJS.AES.decrypt(ciphertext, key);
        if (bytes.sigBytes <= 0) return null;
        
        try {
            const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
            if (!decryptedStr) return null;
            return JSON.parse(decryptedStr);
        } catch (utf8Error) {
            // Ez történik, ha a kulcs rossz és a kapott bájtok nem érvényes UTF-8 karakterek
            return null;
        }
    } catch (error) {
        return null;
    }
};

/**
 * SHA-256 hash-t készít a family_id számára a családi titokból.
 * Így a szerver nem ismeri meg az eredeti titkot, de azonosítani tudja a családot.
 * @param {string} familySecret
 * @returns {string}
 */
export const hashFamilyId = (familySecret) => {
    return CryptoJS.SHA256(familySecret).toString();
};
